export default {
    gravityApi: {
        dev: 'https://gravity.staging.gb.nsoftcdn.com/v1/',
        staging: 'https://gravity.staging.gb.nsoftcdn.com/v1/',
        production: 'https://gravity.de.nsoftcdn.com/v1/'
    },
    results: {
      dev: {
          london: "https://games.staging.gb.nsoftcdn.com/app_dev.php",
          ro: "https://games.staging.gb.nsoftcdn.com/app_dev.php"
      },
      staging: {
          london: "https://games.staging.gb.nsoftcdn.com/app.php",
          ro: "https://games.staging.gb.nsoftcdn.com/app.php",
          serbia: "https://games.staging.gb.nsoftcdn.com/app.php"
      },
      production: {
          london: "https://games.gb.nsoftcdn.com",
          ro: "https://games.ro.nsoftcdn.com",
          serbia: "https://games.gb.nsoftcdn.com"
      }
    },
    socket:{
        channels:{
            retail: "token=token&clientType=user&clientSubType=Operator&token=${token}",
            terminal: "token=token&clientType=Api&clientSubType=terminal&token=${token}&username=${username}",
            web : ""
        }
    },
    paytable:{
        dev: {
            london: "https://games.staging.gb.nsoftcdn.com/api_open/keno/paytable"
        },
        staging: {
            london: "https://games.staging.gb.nsoftcdn.com/api_open/keno/paytable"
        },
        production: {
            london: "https://games.gb.nsoftcdn.com/api_open/keno/paytable",
            de: "https://games.de.nsoftcdn.com/api_open/keno/paytable",
            ro: "https://games.ro.nsoftcdn.com/api_open/keno/paytable",
            ro2: "https://games.ro.nsoftcdn.com/api_open/keno/paytable",
            serbia: "https://games.gb.nsoftcdn.com/api_open/keno/paytable"
        }
    },
    ticketHistory: {
      terminal: {
        dev: {
          london: 'https://menhir.staging.gb.nsoftcdn.com/app.php/terminal-admin/device-tickets/',
        },
        staging: {
          london: 'https://menhir.staging.gb.nsoftcdn.com/app.php/terminal-admin/device-tickets',
        },
        production: {
          london: 'https://menhir.gb.nsoftcdn.com/app.php/terminal-admin/device-tickets',
          de: 'https://menhir.de.nsoftcdn.com/app.php/terminal-admin/device-tickets',
          ro: 'https://menhir.de.nsoftcdn.com.com/app.php/terminal-admin/device-tickets',
          ro2: 'https://menhir.de.nsoftcdn.com.com/app.php/terminal-admin/device-tickets',
          serbia: 'https://menhir.rs.nsoftcdn.com/app.php/terminal-admin/device-tickets',
        }
      }
    },
    frame : {
        local: [
            'http://localhost:8080'
        ],
        dev: [
            'https://keno-dev.nsoft.com'
        ],
        staging: [
            'https://keno-staging.nsoft.com'
        ],
        production: [
            'https://keno.nsoft.com'
        ]
    },
};



// WEBPACK FOOTER //
// endpoints.js